
import { mapGetters } from 'vuex'
import { jsFn } from '@/utils/js-fn'
import profile from '@/utils/profile'
import { Base64 } from 'js-base64'

const bannerTw = require('@/assets/img/htEvent_introduce_banner_tw.jpg')
const bannerCn = require('@/assets/img/htEvent_introduce_banner_cn.jpg')
const bannerEn = require('@/assets/img/htEvent_introduce_banner_en.jpg')

export default {
    name: 'loginV2',
    head: {
        title: function() {
            return {
                inner: this.$t('pageTitle_1'),
                separator: ' '
            }
        }
    },
    data() {
        const validateAccount = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_1')))
            } else if (value.search(/^\+/) === 0) {
                callback(new Error(this.$t('error_26')))
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_1')))
            } else {
                callback()
            }
        }

        return {
            redirectUrlByThird: document.location.origin + '/',
            loading: false,
            showLoginForm: false,
            isCN: jsFn.isCN(),
            clientId: jsFn.isCN() ? profile.clientID['cn'] : profile.clientID['global'],
            isHabookaclass: jsFn.isHabookaclass(),
            entry: this.$route.name === 'htlogin' ? 'hiteach' : 'web',
            loginForm: {
                loginId: '',
                password: ''
            },
            loginRule: {
                loginId: [
                    { validator: validateAccount, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePassword, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        ...mapGetters({
            pageLang: 'getLang',
            isHiTA_UA: 'isHiTA_UA',
            isAClassONE_UA: 'isAClassONE_UA',
            isApp: 'isApp'
        }),
        normalizedLang() {
            const lang = (this.pageLang || '').toLowerCase()
            if (lang === 'zh-cn' || lang === 'cn') return 'cn'
            if (lang === 'en-us' || lang === 'en') return 'en'
            return 'tw'
        },
        heroBanner() {
            switch (this.normalizedLang) {
                case 'cn':
                    return bannerCn
                case 'en':
                    return bannerEn
                default:
                    return bannerTw
            }
        },
        cardSubtitle() {
            return this.showLoginForm ? this.$t('loginV2_formSubtitle') : this.$t('loginV2_registerSubtitle')
        },
        switchPrefix() {
            return this.showLoginForm ? this.$t('loginV2_switchToRegisterPrefix') : this.$t('loginV2_switchToLoginPrefix')
        },
        switchAction() {
            return this.showLoginForm ? this.$t('loginV2_switchToRegisterAction') : this.$t('loginV2_switchToLoginAction')
        },
        availableProviders() {
            const providers = []

            if (!this.isCN) {
                providers.push({
                    name: 'google',
                    icon: require('@/assets/img/thirdIcon/google.png'),
                    label: 'community_google'
                })
                providers.push({
                    name: 'educloudtw',
                    icon: require('@/assets/img/thirdIcon/educloudtw.png'),
                    label: 'community_educloudtw'
                })
            }

            if (this.isCN && !this.isApp && !(this.isHiTA_UA || this.isAClassONE_UA)) {
                providers.push({
                    name: 'wechat',
                    icon: require('@/assets/img/thirdIcon/wc.png'),
                    label: 'community_wechat'
                })
            }

            return providers
        }
    },
    methods: {
        loginSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$store.dispatch('coreApi/login', {
                        id: this.loginForm.loginId,
                        pass: this.loginForm.password
                    }).then((res) => {
                        document.location.href = `/registv2?entry=${this.entry}&app_ver=5.2.72`
                    }).catch(() => {
                        this.$Message.warning({
                            content: this.$t('error_2'),
                            duration: 5,
                            closable: true
                        })
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        },
        showProviderComingSoon(provider) {
            let data = {
                client_id: this.clientId,
                op_redirecturi: `${document.location.origin}/registv2?entry=${this.entry}&bind=${provider.name}&app_ver=5.2.72&redirect_uri=${this.redirectUrlByThird}`
            }
            document.location.href = profile.communityUrl(provider.name, this.redirectUrlByThird, encodeURIComponent(Base64.encode(JSON.stringify(data)), 'utf-8'))
        },
        toggleAuthMode() {
            this.showLoginForm = !this.showLoginForm
        }
    }
}
